<template>
    <Content v-loading="loading">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:20px 0">
            <span style="float: left;">所在位置：</span>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>大数据词云列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="15">
            <el-col :span="4.8" v-for="(item) in list" :key="item.Id" style="height:351px">
                <CloudCard :item="item"></CloudCard>
            </el-col>
        </el-row>
        <div class="prev">
            <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="pageIndex" :page-size="pageSize" @current-change="getList"></el-pagination>
        </div>
    </Content>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
    data() {
        return {
            loading: false,
            list: [],
            total: 0,
            pageIndex: 1,
            pageSize: 20
        };
    },
    components: {},
    mounted() {
        this.MSetMenu("/list");
        this.getList();
    },

    methods: {
        ...mapActions("core", ["AList"]),
        ...mapMutations("menu", ["MSetMenu"]),
        async getList() {
            this.loading = true;
            let params = {
                position: "InsidePages",
                pageIndex: this.pageIndex,
                pageSize: 20
            };
            let result = await this.AList(params);
            if (!result.errorCode) {
                this.list = result.data.dataSource;
                this.total = result.data.rowCount;
                this.loading = false;
            }
        }
    }
};
</script>
<style type="text/less" lang="less" scoped>
.prev {
    width: 400px;
    margin: auto;
    padding-bottom: 50px;
    padding-top: 20px;
    text-align: center;
}
</style>
